import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import formValueSelector from "redux-form/lib/formValueSelector";
import Field from "redux-form/lib/Field";
import Immutable from "immutable";
import isEqual from "lodash/isEqual";

import SchemaField from "../../../component/SchemaField";

import "./ProductAllocationDetails.scss";

const MAX_PATH = [
  "properties",
  "recipients",
  "items",
  "properties",
  "products",
  "items",
  "properties",
  "quantity",
  "maximum"
];

/**
 * DeliveryDetails
 */
class ProductDetails extends Component {
  static propTypes = {
    // ctx: PropTypes.instanceOf(Immutable.Map).isRequired,
    ctxIdx: PropTypes.number.isRequired,
    t: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        uuid: PropTypes.string
      })
    ).isRequired,
    itemContexts: PropTypes.instanceOf(Immutable.List).isRequired,
    schema: PropTypes.instanceOf(Immutable.Map).isRequired
  };

  static defaultProps = {};

  shouldComponentUpdate(nextProps) {
    // for some reason this does not work in the connect() "areMergedPropsEqual" option
    return !isEqual(this.props, nextProps);
  }

  render() {
    const { t, items, itemContexts, schema } = this.props;

    const idPrefix = `form-control-recipients-${this.props.ctxIdx}-`;
    const namePrefix = `recipients[${this.props.ctxIdx}].`;

    return (
      <div className="Cart__Recipient__ProductAllocationDetails mt-3">
        <h2 className="Cart__Step__Header">{t("Which products?")}</h2>
        {items.map((item, idx) => {
          const itemContext = itemContexts.get(idx);
          if (!itemContext) {
            return null;
          }
          const itemNamePrefix = `${namePrefix}products[${idx}].`;
          const itemIdPrefix = `${idPrefix}products-${idx}-`;
          const pcmIdx = itemContext.get("items").findIndex(p => item.productCollectionMemberId === p.get("id"));
          const title = `${itemContext.getIn(["items", pcmIdx, "title"], "")}`;
          return (
            <div className="ProductAllocationRow row" key={item.uuid}>
              <div className="col-12 col-sm-6">
                <div className="row align-items-center">
                  <label htmlFor={`${itemIdPrefix}quantity`} className="col-8">
                    {title}
                  </label>
                  <div className="col-4">
                    <Field
                      name={`${itemNamePrefix}webProductId`}
                      id={`${itemIdPrefix}webProductId`}
                      component="input"
                      type="hidden"
                    />
                    <Field
                      name={`${itemNamePrefix}productCollectionMemberId`}
                      id={`${itemIdPrefix}productCollectionMemberId`}
                      component="input"
                      type="hidden"
                    />
                    <SchemaField
                      name={`${itemNamePrefix}quantity`}
                      type="number"
                      parse={parseInt}
                      schema={schema.setIn(MAX_PATH, item.quantity)}
                      label={false}
                      autoComplete="off"
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

const selectFormValues = formValueSelector("cart");
export default translate()(
  connect(state => ({
    schema: state.cart.get("schema"),
    items: selectFormValues(state, "items"),
    itemContexts: state.cart.getIn(["context", "itemContexts"])
  }))(ProductDetails)
);
